/** Словник назв записів типу (id → назва) для підписів полів-посилань у списках. */
import type { IRecordBatch, IRecordTitleBatch } from '@platform/core/types';

/** Назви записів пакета: назва запису, а без неї — код («CASE-1»); `capped` — API має більше записів, ніж завантажено (стеля). Чиста функція. */
export function titleBatchOf(batch: IRecordBatch): IRecordTitleBatch {
  const titles: Record<string, string> = {};
  for (const r of batch.items) titles[r.id] = r.title || r.display;
  return { titles, capped: batch.total > batch.items.length };
}
